import { OriginBatteryDto } from "app/ApiClient";
import { DEFAULT_BATTERIES } from "slices/batteries/batteriesState";

export const isDefaultBatteryName = (batteryName: string) => DEFAULT_BATTERIES.includes(batteryName);

export const isDvBattery = (battery: OriginBatteryDto) =>
  battery.name.toUpperCase().includes("DV_") || isDefaultBatteryName(battery.name);

export const isRespondableBattery = (battery: OriginBatteryDto) =>
  battery.isRespondable || isDefaultBatteryName(battery.name);

export const getBatteriesByKeyword = (keyword: string) => (battery: OriginBatteryDto) => {
  return (battery.name + " - " + (battery.variableName ?? ""))?.toLowerCase().includes(keyword);
};
